import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BedSection = (): ReactElement => {
  const { t: tBed } = useTranslation('', { keyPrefix: '$local.$bedSection' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  return (
    <section className="base-section bed-section hp-section">
      {/* Bed Section */}
      <div className="pattern-2-col">
        <Link href={tLinks('bedMain')} className="pattern-2-col-background" id="HP_bed">
          <div className="text-2-col">
            <p className="eyebrow">{tBed('bedEyebrow')}</p>
            <h2>{tBed('bedTitle')}</h2>
            <p>{tBed('bedDescription')}</p>
            <span className="btn-main">{tButton('shopNow')}</span>
          </div>
          <img
            src="/images/homepage/hp-st-regis-bed.webp"
            alt={tBed('bedAlt')}
            className="image-2-col hp-bed"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            width={650}
            height={457}
          />
        </Link>
      </div>
    </section>
  );
};

export default BedSection;
